import { useMutation } from "@apollo/client";
import {
    constantsData,
    identifiersData,
    namesData,
    statusTypesData,
} from "data";
import { deleteDistributionMutation, getDistributionsListQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDeleteDistribution = (releaseId, limit, page) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteDistributionAction, { loading }] = useMutation(
        deleteDistributionMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getDistributionsListQuery,
                    variables: {
                        limit,
                        page,
                        ...releaseId && { releaseId },
                    },
                },
            ],
        },
    );

    const { deleteDistributionPending: deleteDistributionPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteDistribution = async (id) => {
        try {
            await deleteDistributionAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.deleteMsgs.success",
                            { entity: `${t("releases.entity")} ${t("labels.distribution")}` },
                        ),
                        statusTypesData.success,
                    ));
                },
                variables: { id },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteDistributionPendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(
                    () => t(
                        "messages.deleteMsgs.pending",
                        { entity: `${t("releases.entity")} ${t("labels.distribution")}` },
                    ),
                    { toastId: `${deleteDistributionPendingToastName}_${toastId}` },
                );
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteDistribution };
};

export default useDeleteDistribution;
